@if (showIcon()) {
  <mat-icon [svgIcon]="icon" [class.mat-icon-rtl-mirror]="rtlMirrorIcon()" muloSvgViewbox></mat-icon>
}
<ng-content></ng-content>
